<template>
  <div id="personal_center_outer" class="container-fluid vue_body_min_height" style="padding: 0;">
    <div id="personal_top_menu_out" class="container" v-if="user != null">
      <div id="personal_top_menu">
        <a v-for="(item, index) in menuTabList"
           :class="[currentTabId == item.id ? specifiedActive : '', specifiedANormal]"
           href="javascript:void(0);"
           @click="topMenuClicked(item)"
          >
          {{item.label}}
        </a>
      </div>
    </div>

    <div class="container personal_info_body" >
      <router-view />
    </div>
  </div>
</template>

<script>
import EventManager from '../js/event-common';
import {Loading} from "element-ui";
export default {
  name: "PersonalCenterPage",
  data() {
    return {
      // user: null,
      flag: 'personal-center-page',
      orderList: null,
      menuTabList: null,
      currentTabId: null,
      isUpdateUser: false,
      allItemList: [
        {
          label: '我的主页',
          id: 'home',
          show: true,
          params: {},
          vueName: 'personalHomeVue'
        },
        {
          label: '我的团体',
          id: 'team',
          show: false,
          params: {},
          vueName: 'personalTeamVue'
        },
        {
          label: '我的会员',
          id: 'member',
          show: false,
          params: {},
          vueName: 'personalMemberVue'
        },
        {
          label: '我的课程',
          id: 'user-trains',
          show: false,
          params: {},
          vueName: 'personalTrainsVue'
        },
        {
          label: '我的申请',
          id: 'member-application',
          show: false,
          params: {},
          vueName: 'personalApplicationVue'
        },
        {
          label: '账户设置',
          id: 'user-setting',
          show: true,
          params: {},
          vueName: 'personalSettingVue'
        },
        {
          label: '通知中心',
          id: 'user-notes',
          show: true,
          params: {},
          vueName: 'personalNoteVue'
        },
        {
          label: '我的认证',
          id: 'certificates',
          show: false,
          params: {},
          vueName: 'personalCertificatesVue'
        },
        {
          label: '裁判员认证',
          show: false,
          id: 'certificate-application',
          vueName: 'personalCertificateApplicationVue',
          params: {
            certId: 0
          }
        },
        {
          label: '教练员认证',
          show: false,
          id: 'coach-certificate-application',
          vueName: 'personalCoachCertApplicationVue',
          params: {
            certId: 0
          }
        }
      ],

      judgeList: [],
      completedJudgeList: null,
      uncompletedJudgeList: null,
      isFirstLoad: true,

      judgeApplyDuration: null,

      coachData: null,

      completedJudgeData: null,
      incompletedJudgeData: null,

      completedCoachData: null,
      inCompletedCoachData: null,

      loadFrequencyNumber: 0,
      isAlreadyAutoTransferPage: false,
    }
  },

  computed: {
    isOfficialOpened() {
      let judgeApplyDuration = this.judgeApplyDuration;
      if (judgeApplyDuration == null) {
        return false;
      }
      let beginString = judgeApplyDuration.begin;
      let enditString = judgeApplyDuration.end;
      let beginDate = this.$moment(beginString);
      let endDate = this.$moment(enditString);
      let now = this.$moment(this.$moment().format("yyyy-MM-DD"), "yyyy-MM-DD");
      console.log(beginString);
      console.log(enditString);
      if ((now - beginDate) >= 0 && (now - endDate) <= 0) {
        return true;
      }
      return false;
    },
    typeNameAllowedList() {
      return this.$store.state.typeNameAllowedList
    },
    isCanVipOperated() {
      let user = this.user;
      if (user == null) {
        return false;
      }
      let typeName = user.typeName;
      if (typeName == null || typeName == '' || this.typeNameAllowedList.indexOf(typeName) >= 0) {
        return true;
      }
      return false;
    },

    eventManager() {
      return this.$store.state.eventManager;
    },

    httpManager() {
      return this.$store.state.http;
    },
    specifiedANormal() {
      return this.isVip ? "personal-top-menu-a-gold" : "personal-top-menu-a-red"
    },
    specifiedActive() {
      return this.isVip ? "personal-top-menu-a-gold-active" : "personal-top-menu-a-red-active";
    },
    isVip() {
      if (this.user == null) {
        return false;
      }
      let user = this.user;
      let memberValidDate = user.memberValidDate;
      if (memberValidDate == null) {
        return false;
      }
      return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
    },
    user() {
      return this.$store.state.user;
    },

    isNeededToVipApplicationPage() {
      let user = this.user;
      let status = user.status;
      let auditStatus = user.auditStatus;
      if (auditStatus > 0 && status == 3) { // 正在进行会员申请 或者 年检
        return true;
      }
      return false;
    },

    isNeededToJudgeApplicationPage() {
      let judgeData = this.incompletedJudgeData;
      if (judgeData != null && judgeData.auditStatus > 0) {
        if (judgeData.status >= 5 && judgeData.status < 7) {
          if (judge.staminaTest == '已通过' && judge.theoryTest == '已通过') {
            return true;
          }
        }
      }
      return false;
    },
    isNeededToCoachApplicationPage() {
      let coachData = this.inCompletedCoachData;
      if (coachData != null && coachData.auditStatus > 0) {
        if (coachData.status == 7) { // 已通过
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        if (this.menuTabList == null) {
          return;
        }
        console.log('路径变化');
        let route = val;
        let name = route.name;
        let params = route.params;
        let selectedItem = null;
        let selectedIndex = null;
        let menuList = this.menuTabList;
        for (let i = 0; i < menuList.length; i++) {
          let item = menuList[i];
          if (item.vueName == name) {
            selectedItem = item;
            selectedIndex = i;
            item.params = params;
            break;
          }
        }

        if (selectedItem != null) {
          console.log(' in menu item');
          this.currentTabId = selectedItem.id;
        } else {
          console.log(' in all item');
          let allList = this.allItemList;
          for(let i = 0; i < allList.length; i++) {
            let item = allList[i];
            if (item.vueName == name) {
              console.log(item.vueName);
              selectedItem = item;
              selectedIndex = i;
              item.show = true;
              item.params = params;
              break;
            }
          }
          if (selectedItem != null) {
            this.currentTabId = selectedItem.id;
          }
          this.dealWithMenuTabList();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$store.commit('setUser', null);
    this.$store.commit('setJudgeList', null);
    this.initCurrentTabId();
    this.loadData();
    // this.loadUserOrderData();
    this.loadJudgeListData();
    this.getJudgeIdentificationDateDuration();
    let _this = this;
    this.eventManager.register(this.flag, EventManager.notificationNameObject.VipApplyCancel, function (data) {
      if (_this.currentTabId == null) {
        _this.currentTabId = _this.allItemList[0].id;
      }
    });

    this.eventManager.register(this.flag, EventManager.notificationNameObject.UserUpdate, function (data) {
      _this.loadData();
    });

    this.eventManager.register(this.flag, EventManager.notificationNameObject.judgeApplicationSuccess, function (data) {
      // 监听裁判员申请成功
      //...
      _this.loadJudgeListData();
    });

    this.eventManager.register(this.flag, EventManager.notificationNameObject.coachApplicationSuccess, function (data) {
      // 监听教练员申请成功
      //...
      _this.loadCoachData();
    });

    this.eventManager.register(this.flag, EventManager.notificationNameObject.updatePersonalCenterTabs, function (data) {
      // 监听裁判员申请成功
      //...
      // _this.loadJudgeListData();
      _this.updateCurrentTab();
    });
  },
  destroyed() {
    this.eventManager.unregisterAllEvents(this.flag);
  },

  methods: {
    getJudgeIdentificationDateDuration() {
      let judgeApplyDuration = this.judgeApplyDuration;
      if (judgeApplyDuration == null) {
        let _this = this;
        this.httpManager.ajax.getJudgeApplyDateData(function (data) {
          if (data.code == 0) {
            let value = data.data.value;
            let duration = JSON.parse(value);
            _this.judgeApplyDuration = duration;
            _this.dealWithApplicationPage();
            _this.splitUnCompletedJudgeData();
            return;
          }
        }, function (data) {

        });
      }
    },

    updateCurrentTab() {
      let route = this.$route;
      let name = route.name;
      let tabList = this.menuTabList;
      for (let i = 0; i < tabList.length; i++) {
        let item = tabList[i];
        if (item.vueName == name) {
          this.currentTabId = item.id;
          break;
        }
      }

    },

    initCurrentTabId() {
      let route = this.$route;
      let name = route.name;
      let params = route.params;
      for (let i = 0; i < this.allItemList.length; i++) {
        let item = this.allItemList[i];
        if (item.vueName == name) {
          this.currentTabId = item.id;
          this.allItemList[i].show = true;
          this.allItemList[i].params = params;
          break;
        }
      }
      this.dealWithMenuTabList();
    },

    updateTrainData(res) {
      this.orderList = res.data;
    },

    dealWithMenuTabList() {
      let tmp = [];

      if (this.completedJudgeData != null) {
        this.allItemList[7].show = true;
      }

      if (this.incompletedJudgeData != null) {
        this.allItemList[8].show = true;
        this.allItemList[8].params.certId = this.incompletedJudgeData.id;
      } else {
        if (this.completedJudgeData != null && this.currentTabId != this.allItemList[9].id) {
          this.allItemList[8].show = false;
        }
      }

      if (this.completedCoachData != null) {
        this.allItemList[7].show = true;
      }

      if (this.inCompletedCoachData != null) {
        this.allItemList[9].show = true;
        this.allItemList[9].params.certId = this.inCompletedCoachData.id;
      } else {
        if (this.completedCoachData != null && this.currentTabId != this.allItemList[9].id) {
          this.allItemList[9].show = false;
        }
      }

      for (let item of this.allItemList) {
        if (item.show) {
          tmp.push(item);
        }
      }
      this.menuTabList = tmp;
      console.log(this.currentTabId);
      console.log(this.loadFrequencyNumber);
      if ((this.currentTabId == this.allItemList[0].id || this.currentTabId == null) && this.loadFrequencyNumber == 1) { // 第一次加载后，处理申请跳转问题
        let user = this.user;
        if (user != null && this.judgeList != null && this.coachData != null) { // 数据都已经加载完成
          // 调整优先级：会员，裁判员，教练员
          if (!this.isAlreadyAutoTransferPage) {
            this.isAlreadyAutoTransferPage = true;
            if (this.isNeededToVipApplicationPage) { // 前往vip申请页面
              this.topMenuClicked(this.allItemList[4]);
            }
            else if (this.isNeededToJudgeApplicationPage) { // 前往裁判员申请页面
              this.topMenuClicked(this.allItemList[8]);
            }
            else if (this.isNeededToCoachApplicationPage) { // 前往教练员申请页面
              this.topMenuClicked(this.allItemList[9]);
            }
          }
        }
        if (this.currentTabId == null) {
          this.isAlreadyAutoTransferPage = true;
          this.topMenuClicked(this.allItemList[0]);
        }
      }
    },

    loadUserOrderData() {
      let _this = this;
      this.httpManager.ajax.getUcOrdersData(function (data) {
        let code = data.code;
        if (code == 0) {
          let tempList = data.data;
          if (tempList == null || tempList.length == 0) {
            return;
          } else {
            let list = [];
            for (let item of tempList) {
              if (item.productId == 0 || item.productId == -1 || item.productId == -2) {
                continue;
              }
              list.push(item);
            }
            if (list.length == 0) {
              return;
            }
            _this.orderList = list;
            _this.allItemList[3].show = true;
            _this.dealWithMenuTabList();
          }

        }
      }, function (data) {

      });
    },

    loadJudgeListData() {
      let _this = this;
      this.httpManager.ajax.getJudgeListSelfData(function (data) {
        let code = data.code;
        if (code == 0) {
          let judgeList = data.data;
          if (judgeList.length == 0 && _this.judgeList.length == 0) {
            _this.$store.commit('setJudgeList', judgeList);
            return;
          }

          _this.judgeList = judgeList;
          _this.splitUnCompletedJudgeData();
          return;
        }
      }, function () {
      });
    },

    updateJudgeAuditStatus(item) {
      console.log(item);
      let neededUpdate = false;
      // return;
      let status = item.status;
      if (item.auditStatus == 0 || status == 6) { // 剔除已完成的item
        return neededUpdate;
      }

      let staminaTest = item.staminaTest;
      if (staminaTest == null) {
        staminaTest = '未进行';
      }
      let theoryTest = item.theoryTest;
      if (theoryTest == null) {
        theoryTest = '未进行';
      }
      if (status == 5 && theoryTest == '已通过' && staminaTest == '已通过') {
        return neededUpdate;
      }

      if (!this.isOfficialOpened) {
        neededUpdate = true;
      } else {
        if (status == 5 && theoryTest != '未进行' && staminaTest != '未进行') {
          neededUpdate = true;
        }
      }

      if (neededUpdate) {
        let params = {
          status: item.status,
          auditStatus: 0,
          id: item.id,
        };
        this.httpManager.ajax.updateJudgeStatusData(params, function (data) {
          // console.log(data);
        }, function (data) {

        });
      }
      return neededUpdate;
    },

    splitUnCompletedJudgeData() {
      if (this.judgeList == null || this.judgeApplyDuration == null) {
        return;
      }
      this.incompletedJudgeData = null;
      this.completedJudgeData = null;
      if (this.judgeList.length > 0) {
        let tempArray = [];
        for (let i = 0; i < this.judgeList.length; i++) {
          let item = this.judgeList[i];
          if (item.auditStatus == 1) {
            if (this.updateJudgeAuditStatus(item)) {
              item.auditStatus = 0;
            };
          }
          tempArray.push(item);
        }
        this.judgeList = tempArray;
        console.log(this.judgeList);
        this.$store.commit('setJudgeList', this.judgeList);

        let firstItem = this.judgeList[0];
        if (firstItem.reviewed != null) {
          this.completedJudgeData = firstItem;
        } else {
          if (firstItem.status >= 5 && firstItem.status < 7) {
            this.completedJudgeData = firstItem;
          }
        }

        let updatedTime = firstItem.updatedTime;
        if (updatedTime != null) {
          let number =  this.$moment().year() - this.$moment(updatedTime).year();
          if (number <= 0 && firstItem.auditStatus == 1) {
            this.incompletedJudgeData = firstItem;
          }
        } else {
          if (firstItem.auditStatus == 1) {
            this.incompletedJudgeData = firstItem;
          }
        }
      }
      if (this.incompletedJudgeData == null) {
        this.allItemList[8].show = false;
      }
      this.dealWithMenuTabList();
    },

    topMenuClicked(item) {
      this.currentTabId = item.id;
      this.$router.push({
        name: item.vueName,
        params: item.params
      });
    },

    dealWithWechatInforGetSuccess(data) {
      let model = data.wxUserInfoModel;

      if (model == null) {
        this.$toast('该微信已被绑定，请更换！');
      } else {
        this.$store.commit('setWechatModel', model);
      }
      this.$router.push({
        name: 'personalPage'
      });

      let isVip = this.isVip;
      this.$store.commit('setShowWechatDialog', true);
      this.currentTabId = this.allItemList[4].id;
    },

    dealWithWechatChange() {
      let query = this.$route.query;
      let code = query.code;
      let state = query.state;
      if (state == this.weichatAutoState.pay) {
        return;
      }

      if (state != undefined) {
        if (code != undefined) {
          let params = {
            code
          };
          if (state == 1001) {
            params.pf = 'pc';
          } else {
            params.pf = 'wx';
          }

          let _this = this;
          this.$toast('微信绑定');
          this.httpManager.ajax.userQrconnect(params, function (data) {
            let code = data.code;
            if (code == 0) {
              let user = data.data;
              _this.dealWithWechatInforGetSuccess(user);
              return;
            }
            _this.$toast('微信数据获取失败！');
          }, function (data) {
            _this.$toast('微信数据获取失败，请重试！');
          });
        }
      }
    },


	updateModifiedValue(modified, callback) {
	  let user = this.user;
	  if (user == null) {
	    return;
	  }
	  let params = {};
	  params.id = user.id;
	  params.modified = modified;

	  this.httpManager.ajax.postUserModifiedChangeRequest(params, function (data) {
	    let code = data.code;
	    if (code == 0) {
	      callback();
	      return;
	    }
	    _this.$toast('更新失败！');
	  }, function (data) {
	    _this.$toast('更新失败，请重试！');
	  });
	},

	updateAuditStatus(status, callback) {
	  let user = this.user;
	  if (user == null) {
	    return;
	  }
	  let params = {};
	  params.id = user.id;
	  params.auditStatus = status;
	  let _this = this;
	  this.httpManager.ajax.postUpdateUserAuditStatusRequest(params, function (data) {
	    let code = data.code;
	    if (code == 0) {
	      callback();
	      return;
	    }
	    _this.$toast('更新失败！');
	  }, function (data) {
	    _this.$toast('更新失败，请重试！');
	  });
	},

    closeUserMemberApplication() {
      if (this.judgeApplyDuration == null) {
        return;
      }
      let _this = this;
      let user = this.user;
	  let neededUpdateModified = false;
	  if (user.modified != 0) {
		  neededUpdateModified = true;
	  }

	  this.updateAuditStatus(0, function() {
		  if (neededUpdateModified) {
			  _this.updateModifiedValue(0, function() {
				  _this.loadData();
			  })
		  }
	  });
    },

    dealWithApplicationPage() {
      if (!this.isCanVipOperated) {
        this.allItemList[2].show = false;
        this.allItemList[4].show = false;
        return;
      }

      let user = this.user;
      let status = user.status;
      let memberValidDate = user.memberValidDate;
      let auditStatus = user.auditStatus;

      if (auditStatus > 0) { // 已然开始 会员申请或者审核
        if (memberValidDate != null) {
          this.allItemList[4].label = "会员激活";
        } else {
          this.allItemList[2].show = false;
        }

        if (status == 3) {
          this.allItemList[4].show = true;
          return;
        }

        // 窗口期...
        if (this.isOfficialOpened) {
          this.allItemList[4].show = true;
        } else {
          //...更新状态
          this.closeUserMemberApplication();
        }
      } else {
        if (status == 3) { // 已然是会员
          this.allItemList[2].show = true;
        }
        this.allItemList[4].show = false;
      }
      this.initCurrentTabId();
    },
    loadData() {
      if (this.isUpdateUser) {
        return;
      }
      let loadFlags = null;
      if (this.user == null) {
        loadFlags = Loading.service({
          target: document.getElementById('app'),
          fullscreen: true
        });
      }
      this.isUpdateUser = true;
      let _this = this;
      this.httpManager.ajax.ucProfile(function (data) {
        _this.isUpdateUser = false;
        _this.loadFrequencyNumber += 1;
        if (loadFlags != null) {
          loadFlags.close();
        }
        let code = data.code;
        if (code == 0) {
          let user = data.data;
          let isTeam = user.isTeam;
          if (isTeam == 1) {
            let params = _this.$route.params;
            let l = _this.$router.resolve({
              name: 'groupPage',
              params
            });
            window.location.href = l.href;
            return;
          }

          _this.$store.commit('setUser', user);

          if (_this.isVip) {
            _this.allItemList[2].show = true;
            _this.allItemList[1].show = true;
          } else {
            _this.allItemList[2].show = false;
            _this.allItemList[1].show = false;
          }

          _this.dealWithApplicationPage();

          _this.dealWithWechatChange();

          _this.dealWithMenuTabList();

          if (_this.coachData == null) {
            _this.loadCoachData();
          }

        } else {
          _this.$toast('请求失败！');
        }
      }, function (data) {
        if (loadFlags != null) {
          loadFlags.close();
        }
        _this.isUpdateUser = false;
        if (data.code != -1) {
          _this.$toast('请求失败，请重试！');
        }
      })
    },

    loadCoachData() {
      let user = this.user;
      if (user == null) {
        console.log('user == null, 无法请求裁判员数据');
        return;
      }

      let params = {
        userId: user.id
      };

      let _this = this;
      this.httpManager.ajax.getUserCoachListData(params, function(data) {
        console.log('请求成功');
        console.log(data);
        let code = data.code;
        if (code == 0) {
          let coachList = data.data;
          if (coachList == null) {
            coachList = [];
          }
          _this.coachData = coachList;
          _this.$store.commit("setCoachData", coachList);
          _this.dealWithCoachData();
          _this.dealWithMenuTabList();
          return;
        }

        console.log('请求失败！');
        console.log(data);
      }, function(data) {
        console.log('请求失败');
        console.log(data);
      });
    },

    dealWithCoachData() {
      let coachData = this.coachData;
      if (coachData.length == 0) {
        this.completedCoachData = null;
        this.inCompletedCoachData = null;
        if (this.currentTabId != this.allItemList[9].id) {
          this.allItemList[9].show = false;
        }
        return;
      }
      this.completedCoachData = null;
      this.inCompletedCoachData = null;

      for (let i = 0; i < coachData.length; i++) {
        let item = coachData[i];
        let coach = item.coach;
        if (coach == undefined || coach == null) {
          continue;
        }
        let auditStatus = coach.auditStatus;
        if (auditStatus > 0) {
          this.inCompletedCoachData = coach;
        }
        if (coach.status == 7) { // 申请成功的
          this.completedCoachData = coach;
        }
      }
      if (this.inCompletedCoachData == null) {
        this.allItemList[9].show = false;
      }
      this.dealWithMenuTabList();
    }
  }
}
</script>

<style scoped>

  #personal_center_outer {
    background-image: url("../assets/shl_personal_center_top_bg.png");
    background-size: auto 100px;
    background-repeat: no-repeat;
    background-position: center top;
    background-color: white;
  }

  #personal_top_menu_out {
    /*width: 100%;*/
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 115px;
  }

  #personal_top_menu {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .personal-top-menu-a-gold, .personal-top-menu-a-red {
    color: #333;
  }

  .personal-top-menu-a-gold-active, .personal-top-menu-a-red-active {
    pointer-events: none;
  }

  .personal-top-menu-a-gold:hover, .personal-top-menu-a-gold-active{
    color: #cbb042;
  }

  .personal-top-menu-a-gold-active {
    border-bottom: solid 2px #cbb042;
  }

  .personal-top-menu-a-red:hover, .personal-top-menu-a-red-active{
    color: #e71432;
  }
  .personal-top-menu-a-red-active {
    border-bottom: solid 2px #e71432;
  }

  #personal_top_menu > a {
    text-decoration: none;
    font-size: 1.5rem;
    margin-left: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center;
  }


  .personal_info_body {
    /*width: 100%;*/
    padding-bottom: 30px;
    padding-left: 0;
    padding-right: 0;
    margin-top: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenterPage.vue